<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule"  size="small" ref="dataForm"  label-width="120px"
     v-loading="dataLoading" style="width:100%;"  element-loading-text=""  element-loading-spinner="el-icon-loading"
    >
      <el-form-item label="产品主题编号" prop="hierarchyNo">
        <el-input v-model="dataForm.hierarchyNo" placeholder="产品主题编号"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="产品主题名称" prop="hierarchyName">
        <el-input v-model="dataForm.hierarchyName" placeholder="产品主题名称"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="产品主题说明" prop="description">
        <el-input v-model="dataForm.description" placeholder="产品主题说明"  size="small" maxlength="100"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" size="small"  :disabled="dataLoading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {info,add,update} from '@/api/modules/producthierarchy'
  export default {
    data () {
      return {
        visible: false,
        dataLoading: false,
        dataForm: {
          id: 0,
          hierarchyNo: '',
          hierarchyName: '',
          description: ''
        },
        dataRule: {
          hierarchyNo: [
            { required: true, message: '产品主题编号不能为空', trigger: 'blur' }
          ],
          hierarchyName: [
            { required: true, message: '产品主题名称不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            info({id:this.dataForm.id}).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.hierarchyNo = data.productHierarchy.hierarchyNo
                this.dataForm.hierarchyName = data.productHierarchy.hierarchyName
                this.dataForm.description = data.productHierarchy.description
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
          	this.dataLoading = true;
            var params = {
              'id': this.dataForm.id || undefined,
              'hierarchyNo': this.dataForm.hierarchyNo,
              'hierarchyName': this.dataForm.hierarchyName,
              'description': this.dataForm.description
            }
            var tick = !this.dataForm.id ? add(params) : update(params)
            tick.then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
	              	this.dataLoading = false;
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
                this.dataLoading = false;
              }
            })
          }
        })
      }
    }
  }
</script>
